import type { ReactNode } from "react";

/** One label/amount line inside a PaymentsSummaryBox. */
export function PaymentsSummaryItem({ children }: { children: ReactNode }) {
  return <div className="flex w-full justify-between">{children}</div>;
}
